import React from "react";

/**
 * "Total Terminal Vision" brand mark — renders the uploaded logo asset.
 * Sized responsively via the `size` prop; caller can also override by
 * passing an explicit className.
 */
export default function TotalTerminalVisionLogo({ className = "", size = "xl" }) {
    const sizes = {
        md: "w-52 md:w-64",
        lg: "w-64 md:w-80",
        xl: "w-72 md:w-[26rem]",
        "2xl": "w-80 md:w-[32rem] lg:w-[36rem]",
    };
    return (
        <img
            src="/total-terminal-vision-logo.png"
            alt="Total Terminal Vision"
            className={`${sizes[size] || sizes.xl} h-auto object-contain select-none ${className}`}
            draggable={false}
            data-testid="ttv-logo"
        />
    );
}
